import { doPost2 } from './common'

export const sendPrivacyRightsRequest = async ({
  type,
  firstName,
  lastName,
  details,
  stateProvince,
  email,
  token,
  streetAddress,
  country,
  phone,
  optingOutOrSharing,
  privacyRightsRequest,
} = {}) => {
  const payload = {
    email,
    type,
    firstName,
    lastName,
    phone,
    details,
    stateProvince,
    country,
    streetAddress,
    optingOutOrSharing,
    privacyRightsRequest: `${privacyRightsRequest} - From: ${
      process.env.BASE_URL || process.env.BTM_SITE || 'dailybreak.com'
    }`,
    token,
  }

  return postPrivacyRightsRequest(payload)
}

// Structured form (BR-5384): sent as built; the API records the site itself.
export const sendStructuredPrivacyRightsRequest = payload =>
  postPrivacyRightsRequest(payload)

const postPrivacyRightsRequest = async payload => {
  try {
    const response = await doPost2(`/privacy-rights-request`, payload)

    let data = {}
    try {
      data = await response.json()
    } catch (e) {
      // Response might not be JSON
    }

    if (response.ok) {
      return {
        status: response.status,
        success: true,
        detail: data,
      }
    }

    // Return error details for proper error handling
    return {
      status: response.status,
      success: false,
      message:
        data.message || data.error || 'Failed to submit privacy rights request',
      detail: data,
    }
  } catch (error) {
    // Network or other errors
    return {
      status: 0,
      success: false,
      message: error?.message || 'Network error. Please try again.',
      detail: { error },
    }
  }
}
